var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 137,
    viewBox: "0 0 176 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.825 0H11.1748C5.00359 0 0 5.00328 0 11.1745V125.714C0 131.885 5.00359 136.889 11.1748 136.889H164.825C170.996 136.889 176 131.885 176 125.714V11.1745C176 5.00328 170.997 0 164.825 0ZM164.825 11.1745V92.4444L142.803 72.4223C139.493 69.4136 134.402 69.5337 131.24 72.6991L108.952 94.9838L65.0055 42.4912C61.6836 38.5241 55.599 38.4851 52.2273 42.4046L11.1748 90.1147V11.1745H164.825ZM117.333 40.5078C117.333 32.0206 124.211 25.1426 132.698 25.1426C141.185 25.1426 148.063 32.0206 148.063 40.5078C148.063 48.995 141.186 55.8727 132.698 55.8727C124.211 55.873 117.333 48.995 117.333 40.5078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageIcon);
export default __webpack_public_path__ + "static/media/no-image-icon.8b12e5284ff5f659582c1c811cad2776.svg";
export { ForwardRef as ReactComponent };